import { z } from 'zod';

const ItemSchema = z.object({
    product_variation_id: z.string(),
    quantity: z.coerce.number().min(1, 'Quantity must be at least 1'),
    wholesale_price: z.coerce
        .number()
        .min(0, 'Wholesale price must be at least 0'),
    retail_price: z.coerce.number().min(0, 'Retail price must be at least 0'),
    available_quantity: z.coerce.number().optional(),
    purchase_price: z.coerce
        .number()
        .min(0, 'Purchase price must be at least 0'),
    product_name: z.string().optional(),
});

export const ConfirmOrderFormSchema = z.object({
    paid_amount: z.coerce.number().min(0, 'Paid amount must be at least 0'),
    items: z.array(ItemSchema),
});

export type ConfirmOrderForm = z.infer<typeof ConfirmOrderFormSchema>;
export type ConfirmOrderFormInpuut = z.input<typeof ConfirmOrderFormSchema>;
export type ConfirmOrderFormOutput = z.output<typeof ConfirmOrderFormSchema>;
